import { render, staticRenderFns } from "./ModalSelectSeminarStudyCategory.vue?vue&type=template&id=390148a0&scoped=true&lang=pug&"
import script from "./ModalSelectSeminarStudyCategory.vue?vue&type=script&lang=ts&"
export * from "./ModalSelectSeminarStudyCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390148a0",
  null
  
)

export default component.exports